import { Table } from '@skytech/ui'
import { useDispatch, useSelector } from 'react-redux'

import ListLoader from '@/components/util/ListLoader'
import {
  getPriceListExceedsLimit,
  getVisiblePrices,
  increaseListRenderLimit,
} from '@/ducks/devicePolicyReducer'

import { Translation } from '../i18n/Translation'

import DevicePolicyPriceListFilter from './DevicePolicyPriceListFilter'
import DevicePolicyPriceListItem from './DevicePolicyPriceListItem'

import './device-policy-price-list.scss'

const DevicePolicyPriceList = () => {
  const dispatch = useDispatch()
  const prices = useSelector(getVisiblePrices)

  return (
    <div className="device-policy-price-list">
      <DevicePolicyPriceListFilter />
      <Table rowHeight="tall">
        <thead>
          <tr>
            <th>
              <Translation id="Policy group" />
            </th>
            <th>
              <Translation id="Product" />
            </th>

            <th>
              <Translation id="Price" />
            </th>
          </tr>
        </thead>
        <tbody>
          {prices.map(price => (
            <DevicePolicyPriceListItem key={price.id} {...price} />
          ))}
        </tbody>
      </Table>
      <ListLoader
        // @ts-ignore
        conditionSelector={getPriceListExceedsLimit}
        action={() => dispatch(increaseListRenderLimit())}
      />
    </div>
  )
}

export default DevicePolicyPriceList
